export default __webpack_public_path__ + "static/media/2018_thumb.415c5a3d.jpg";